<template>
  <div>
      <div class="mt-4">
        <label class="float-left block mb-1 text-xs leading-4 text-gray-600 cursor-default box-border">
          {{label}}
        </label>
          <input
            @input="handleInput"
            :disabled="disabled"
            :placeholder="placeholder"
            :type="type"
            :value="value"
            class="py-2 px-3 mb-2 w-full text-sm rounded cursor-text box-border shadow-xs placeholder-gray-400 focus:placeholder-gray-200"
            style="line-height: 26px; box-shadow: rgba(15, 15, 15, 0.1) 0px 0px 0px 1px inset; background: rgba(242, 241, 238, 0.6); cursor: text; outline: 0px;"
          />
      </div>
  </div>
</template>

<script>
  export default {
    name: 'inputWithLabel',
    props: {
        type:String,
        input:String,
        placeholder:String,
        label:String,
        disabled:Boolean,
        value: String,
    },
    computed:{
      isComplete(){
        return this.email == "" ? false : true;
      },
    },
    methods:{
      handleInput (e) {
        this.$emit('input', e.target.value)
      }
    },
  };
</script>

<style>

</style>